// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Ugbz","label":"Category_label__ng2CD","content":"Category_content__3aAS0","header":"Category_header__3522W","location":"Category_location__YGAYe"};